import { useState, useEffect } from 'react';

export const useIsBigScreen = (threshold = 1540) => {
  const [bigScreen, setBigScreen] = useState(window.innerWidth > threshold);

  useEffect(() => {
    function handleResize() {
      setBigScreen(window.innerWidth > threshold);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [threshold]);

  return bigScreen;
};
